import request from '@/utils/request'
// 购物车列表
export function cartList(params) {
  return request({
    url: '/member/cartItem/list',
    method: 'get',
    params: params
  })
}
// 加入购物车
export function cartAdd(params) {
  return request({
    url: '/member/cartItem/add',
    method: 'post',
    params: params
  })
}
// 删除购物车
export function cartDels(ids) {
  return request({
    url: '/member/cartItem/delete?ids=' + ids,
    method: 'post'
  })
}